import React, { useCallback, useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { BadgeCheck, X } from 'lucide-react';
const names = ['María José', 'Lucas', 'Sofía', 'Martín', 'Valentina', 'Julián', 'Camila', 'Federico', 'Agustina', 'Nicolás', 'Florencia', 'Matías', 'Carolina', 'Gonzalo', 'Micaela', 'Sebastián', 'Rocío', 'Diego', 'Belén', 'Tomás', 'Antonella', 'Ramiro', 'Guadalupe', 'Ignacio'];
const locations = ['CABA', 'La Plata, Bs. As.', 'Córdoba', 'Rosario, Santa Fe', 'Mendoza', 'Mar del Plata', 'San Miguel de Tucumán', 'Salta', 'Neuquén', 'Bahía Blanca', 'Santa Fe', 'Resistencia, Chaco', 'Posadas, Misiones', 'San Juan', 'Paraná, Entre Ríos', 'Bariloche', 'Corrientes', 'Quilmes, Bs. As.'];
const offers = [{
  name: 'el Megapack',
  price: '$34.990'
}, {
  name: 'el Kit Protocolo',
  price: '$19.990'
}];
const pick = <T,>(arr: T[]): T => arr[Math.floor(Math.random() * arr.length)];
interface Sale {
  key: number;
  name: string;
  location: string;
  offer: string;
  price: string;
  when: string;
}
const buildSale = (): Sale => {
  const offer = pick(offers);
  const minutesAgo = Math.floor(Math.random() * 8);
  return {
    key: Date.now(),
    name: pick(names),
    location: pick(locations),
    offer: offer.name,
    price: offer.price,
    when: minutesAgo === 0 ? 'hace instantes' : `hace ${minutesAgo} min`
  };
};
export function PurchaseNotification() {
  const [sale, setSale] = useState<Sale | null>(null);
  const showNext = useCallback(() => {
    setSale(buildSale());
    // Keep it on screen for ~6s
    const hideTimer = window.setTimeout(() => setSale(null), 6000);
    // Schedule the next one 40–60s after this one appears
    const nextDelay = 40000 + Math.random() * 20000;
    const nextTimer = window.setTimeout(showNext, nextDelay);
    return () => {
      window.clearTimeout(hideTimer);
      window.clearTimeout(nextTimer);
    };
  }, []);
  useEffect(() => {
    // First notification after a short delay
    const firstTimer = window.setTimeout(showNext, 9000);
    return () => window.clearTimeout(firstTimer);
  }, [showNext]);
  return <div className="fixed bottom-4 left-4 z-50 pointer-events-none max-w-[calc(100vw-2rem)]" data-id="element-177">
      <AnimatePresence data-id="element-178">
        {sale && <motion.div key={sale.key} initial={{
        opacity: 0,
        y: 30,
        scale: 0.9
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 20,
        scale: 0.95
      }} transition={{
        type: 'spring',
        stiffness: 260,
        damping: 24
      }} role="status" aria-live="polite" className="pointer-events-auto w-[320px] max-w-full bg-white rounded-xl shadow-2xl border border-slate-200 p-3 flex items-start gap-3" data-id="element-179">
            <div className="flex-shrink-0 w-11 h-11 rounded-full bg-brand-navy flex items-center justify-center" data-id="element-180">
              <BadgeCheck className="w-6 h-6 text-brand-gold" data-id="element-181" />
            </div>

            <div className="min-w-0 flex-grow" data-id="element-182">
              <div className="flex items-center gap-1.5 mb-0.5" data-id="element-183">
                <span className="text-[10px] font-bold uppercase tracking-wider text-green-600" data-id="element-184">
                  Compra verificada
                </span>
                <span className="w-1 h-1 rounded-full bg-slate-300" data-id="element-185" />
                <span className="text-[10px] text-slate-400" data-id="element-186">{sale.when}</span>
              </div>
              <p className="text-sm text-slate-800 leading-snug" data-id="element-187">
                <strong className="font-semibold text-brand-navy" data-id="element-188">
                  {sale.name}
                </strong>{' '}
                de {sale.location} compró{' '}
                <strong className="font-semibold text-brand-navy" data-id="element-189">
                  {sale.offer}
                </strong>
              </p>
              <p className="text-xs text-brand-gold font-bold mt-0.5" data-id="element-190">
                {sale.price} ARS
              </p>
            </div>

            <button type="button" onClick={() => setSale(null)} aria-label="Cerrar notificación" className="flex-shrink-0 text-slate-300 hover:text-slate-500 transition-colors" data-id="element-191">
              <X className="w-4 h-4" data-id="element-192" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}